import { useEffect, useState } from 'react';
import { Button, Tab } from 'react-bootstrap';
import { $view as $viewSignal } from 'signals/global.signals';

const TabNav = ({
  tabs,
  activeTab,
  onClick,
  TabComponents,
  shouldQueryParamUpdate = true,
  $view = $viewSignal,
  async = false, // new prop to control async loading
}) => {
  const searchParams = new URLSearchParams(window.location.search);
  // For async mode, track which tabs have been activated
  const [activatedTabs, setActivatedTabs] = useState(() => {
    if (!async) return [];
    // If async, only activate the initial tab
    if (tabs?.find(tab => tab === searchParams.get('tab'))) {
      return [searchParams.get('tab')];
    }
    return [tabs?.[0]];
  });

  const handleClick = (newTab) => {
    if (shouldQueryParamUpdate) {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set('tab', newTab);
      window.history.pushState(null, '', `?${queryParams.toString()}`);
    }

    if (onClick) {
      onClick(newTab);
    } else {
      $view.update({ activeTab: newTab });
    }

    if (async) {
      setActivatedTabs((prev) => (prev.includes(newTab) ? prev : [...prev, newTab]));
    }
  };

  // On mount, set the initial tab (and activate it if async)
  useEffect(() => {
    const initialTab = tabs?.find(tab => tab === searchParams.get('tab')) ? searchParams.get('tab') : tabs?.[0];
    handleClick(initialTab);
    // eslint-disable-next-line
  }, []);

  const activeClasses = 'fw-600 text-primary h6';
  const inactiveClasses = 'fw-500 text-white h6';

  return (
    <>
      <div className="d-flex align-items-center mb-16 border-bottom border-2 border-gray-200 gap-40 overflow-auto">
        {tabs.map((tab, idx) => (
          <div key={`tab-${tab}-${idx}`} className="mb-8 flex-shrink-0">
            <Button className="bg-gray-800 border-0 p-0" onClick={() => handleClick(tab)} size="sm">
              <div className={`${tab === activeTab ? activeClasses : inactiveClasses}`}>
                {tab}
              </div>
            </Button>
          </div>
        ))}
      </div>
      <Tab.Container activeKey={activeTab} className="border-0">
        <Tab.Content className="w-100 pb-24">
          {TabComponents.map((TabComponent, tabIdx) => {
            const tabKey = tabs[tabIdx];
            // If async, only render the component if the tab has been activated
            if (async) {
              if (!activatedTabs.includes(tabKey)) return null;
              return (
                <Tab.Pane eventKey={tabKey} key={`pane-${tabKey}-${tabIdx}`}>
                  {tabKey === activeTab ? TabComponent : null}
                </Tab.Pane>
              );
            }
            // If not async, render all as before
            return (
              <Tab.Pane eventKey={tabKey} key={`pane-${tabKey}-${tabIdx}`}>
                {TabComponent}
              </Tab.Pane>
            );
          })}
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

export default TabNav;
